module.exports = __webpack_public_path__ + "img/logo.9e7c7781.jpg";